import * as ReactDOM from 'react-dom/client'
import './assets/css/tailwind.css'
import App from './App'
import { BrowserRouter as Router, useLocation } from 'react-router-dom'
import { Provider } from 'react-redux'
import { persistor, store } from './store'
import { PersistGate } from 'redux-persist/integration/react'
import { Toaster } from 'react-hot-toast'
import GTMProvider from './providers/GTMProvider/Index'


const rootElement = document.getElementById('root');
if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
        // END: ed8c6549bwf9
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router>
                    <GTMProvider>
                        <App />
                        <Toaster position="top-center" reverseOrder={false} />
                    </GTMProvider>
                </Router>
            </PersistGate>
        </Provider>
    )
} else {
    throw new Error('Could not find root element');
}
